import BaseFormPage from "../../../../../base/BaseFormPage";
import EmploymentPresenter from "./EmploymentPresenter";
import FindObjectUseCase from "../../../../../usecases/object/FindObjectUseCase";
import RegionTab from "../../../../../components/common/RegionTab";
import ShceduleTable from "./tables/ScheduleTable";
import LeaveCredits from "./tables/LeaveCredits";
import ContributionDeduction from "./tables/ContributionDeduction";
import AllowanceAndBeni from "./tables/AllowanceAndBeni";
import { formattedRate } from "../../../../../components/common/Converter";
import Hierarchy from "../../../../../components/common/Hierarchy";
import FormFactory from "../../../../../components/FormFactory";
import ServiceRecord from "./tables/ServiceRecord";
import RemarksPage from "./tables/RemarksPage";
import { findObjectUseCase } from "../../../../../usecases/object";
import LeaveCard from "./tables/LeaveCard";

export default class Employment extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new EmploymentPresenter(this);
    this.state = {
      salaryGrade: "",
      employment: [],
      selectedSalary: "",
      isShown: false,
      fields: ["region", "office", "division", "section", "unit", "cluster"],
    };
  }

  isSuperAdmin() {
    return (this.getCurrentRoles() ?? []).some(
      (role) => role?.id === "Super Admin",
    );
  }

  getCollectionName() {
    return "employees";
  }

  findObjectUseCase() {
    return new FindObjectUseCase();
  }

  async componentDidMount() {
    try {
      this.presenter.componentDidMount();

      const object = this.props.object;

      const employmentType = object.employmentType?.name || "";
      this.setState({ isShown: employmentType === "Job Order" });

      if (object?.position) {
        this.presenter.onChange(
          object?.position?.salaryPointer,
          "salaryPointer",
        );
      }
    } catch (error) {
      console.error("Error in componentDidMount:", error);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.object !== this.props.object) {
      if (this.props.object.employmentType) {
        const employment = await this.findObjectUseCase().execute(
          "employment_type",
          {
            where: { id: this.props.object.employmentType.id },
            keys: ["name", "types"],
          },
        );
        console.log("EMPLOYMENT: ", employment);
        this.setState({ plantillType: employment[0]?.types || "" });
      }
    }
  }

  async onChange(value, field) {
    if (field === "position") {
      const listOfPos = await findObjectUseCase().execute("position_titles", {
        where: { id: value.id },
        keys: ["salaryPointer"],
        include: ["salaryPointer"],
      });

      if (listOfPos.length > 0) {
        this.presenter.onChange(listOfPos[0], "salaryPointer");
        const salaryGrade = `${
          listOfPos[0]?.salaryPointer?.name
        } (₱ ${formattedRate(
          listOfPos[0]?.salaryPointer["Monthly Rate"],
        )} per month)`;

        this.presenter.onChange(salaryGrade, "salaryGrade");
        this.presenter.onChange(
          listOfPos?.[0]?.salaryPointer?.salaryCode,
          "salaryCode",
        );
      }
    }

    this.presenter.onChange(value, field);
    if (field === "employmentType") {
      this.setState({ isShown: value.name === "Job Order" });
    }
  }

  handleObjectChange(hierarchy) {
    this.setObject(hierarchy);
    console.log("HEIGH: ", hierarchy);
  }

  setObject(object) {
    const newObj = { ...this.props.object, ...object };
    // console.log("newOBJ: ", object);
    this.props.setObject(newObj);
    return object;
  }

  scheduleChange(value) {
    // const { selectedSchedule, scheduleHistory = {} } = this.props.object;
    // const todayKey = formatTodayKey();
    // const dayHistory = scheduleHistory[todayKey] || [];
    // const historyItem = {
    //   startingDate: selectedSchedule?.startingDate,
    //   scheduleArray: selectedSchedule?.scheduleArray,
    // };

    // const isDifferent =
    //   selectedSchedule?.id &&
    //   selectedSchedule.id !== value.id

    // const updatedScheduleHistory = isDifferent
    //   ? { ...scheduleHistory, [todayKey]: [...dayHistory, historyItem].slice(-10) }
    //   : scheduleHistory;

    // this.setObject({
    //   selectedSchedule: value ? value : { id: " " },
    // });

    this.onChange(value, "selectedSchedule");
  }

  // allowanceChange(value) {
  //   this.onChange(value, "selectedAllowance");
  // }

  // allowanceData(arrObj) {
  //   const object = {
  //     allowance: arrObj,
  //   };
  //   if (Array.isArray(arrObj) && arrObj.length > 0) {
  //     return this.setObject(object);
  //   }
  // }

  render() {
    const { isShown } = this.state;
    const object = this.props.object;
    console.log("ob;: ", object);
    const isSuperAdmin = this.isSuperAdmin();
    // const employmentType = employment.find(
    //   (item) => item?.name === object?.employmentType?.name
    // );
    // const isPlantilla = employmentType?.types === "Non-Plantilla";

    const tabs = [];

    if (isSuperAdmin) {
      tabs.push({
        title: "Leave Credits",
        content: <LeaveCredits object={object} />,
      });
    }

    if (this.props.object_ID !== undefined) {
      tabs.push(
        {
          title: "Service Record",
          content: <ServiceRecord object={object} />,
        },
        {
          title: "Remarks",
          content: <RemarksPage object={object} />,
        },
      );

      if (isSuperAdmin) {
        tabs.push(
          {
            title: "Contribution and Deductions",
            content: <ContributionDeduction object={object} />,
          },
          {
            title: "Allowance and Benefits",
            content: (
              <AllowanceAndBeni
                object={object}
                object_ID={this.props.object_ID}
              />
            ),
          },
          {
            title: "Leave Cards",
            content: (
              <LeaveCard object={object} object_ID={this.props.object_ID} />
            ),
          },
        );

        tabs.unshift({
          title: "Schedule",
          content: (
            <ShceduleTable
              object={object}
              object_ID={this.props.object_ID}
              scheduleChange={this.scheduleChange.bind(this)}
            />
          ),
        });

        // {
        //   title: "Loans",
        //   content: <LoansPage object={object} />,
        // },

        // medical record
        // {
        //   title: "Medical Record",
        //   content: <MedicalRecord object={object} />,
        // },
        // {
        //   title: "Consultation",
        //   content: <Consultation object={object} />,
        // },
        // {
        //   title: "Detal Consultation",
        //   content: <DentalConsultation object={object} />,
        // }
      }
    }

    const tabContents = tabs.map((tab) => tab.content);
    // const schema = this.getSchema(this.getCollectionName());
    const schema = {
      ...this.props.schema,
      fields: {
        ...this.props.schema.fields,
        agency: { ...this.props.schema.fields.agency, required: "true" },
        hired: { ...this.props.schema.fields.hired, required: "true" },
        twentyFourSeven: {
          ...this.props.schema.fields.twentyFourSeven,
          required: "true",
        },
        isSubmitted: {
          ...this.props.schema.fields.isSubmitted,
          required: "true",
        },
        isGraduated: {
          ...this.props.schema.fields.isGraduated,
          required: "true",
        },
      },
    };
    // const isUserRoles = this?.getCurrentRoles()[0]?.id === "user";

    const excludeSecField = [
      !isSuperAdmin && "designations",
      !isSuperAdmin && "twentyFourSeven",
      !isSuperAdmin && "isSubmitted",
      !isSuperAdmin && "isGraduated",
      isSuperAdmin && !isShown && "isGraduated",
      isSuperAdmin && !isShown && "isSubmitted",
    ];
    const payCodeField = Object.keys(schema.fields).filter((key) =>
      excludeSecField.includes(key),
    );

    if (this.state?.plantillType === "Plantilla") {
      payCodeField.push("nonRegPosition");
    } else if (this.state?.plantillType === "Non-Plantilla") {
      payCodeField.push("position");
    }

    return (
      <>
        {/* <Divider icon={"bi bi-person-vcard"} title={"Government ID"} /> */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.presenter.handleNext();
          }}
        >
          <div className="row">
            <FormFactory
              className="col-lg-4 p-1 mt-2"
              uppercase
              schema={schema}
              showTabs={false}
              object={object}
              onChange={this.onChange.bind(this)}
              excludeFields={payCodeField}
            />
          </div>

          <div className="row mb-3 mt-3">
            {/* {!isUserRoles && (
              <Hierarchy
                className="col-lg-4 p-1 mb-3"
                object={object}
                required
                handleObjectChange={this.handleObjectChange.bind(this)}
              />
            )} */}
            <Hierarchy
              className="col-lg-4 p-1 mb-3"
              object={object}
              required
              handleObjectChange={this.handleObjectChange.bind(this)}
            />
          </div>

          {/* {this.props.hideAllTabs && ( */}
          <div className="row">
            <div style={{ width: "92%", margin: "auto", marginBottom: "1rem" }}>
              <hr />
            </div>

            <RegionTab
              key={`employment-tabs-${isSuperAdmin ? "admin" : "user"}-${tabs.length}`}
              tabs={tabs}
              tabContents={tabContents}
            />
          </div>
          {/* )} */}

          <div className="mt-4 d-flex justify-content-end">
            <div className="border" style={{ borderRadius: "4px" }}>
              <button
                style={{ borderRadius: "4px 0 0 4px", backgroundColor: "#fff" }}
                type="button"
                className="btn  fs-sm me-0"
                onClick={this.props.onClickPrev}
              >
                Previous
              </button>
              <button
                type="submit"
                style={{
                  borderRadius: "0 4px 4px 0",
                  backgroundColor: "#29457c",
                  color: "#fff",
                }}
                className="btn  fs-sm"
              >
                Next
              </button>
            </div>
          </div>
        </form>
      </>
    );
  }
}
